var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('GmapMap',{staticStyle:{"width":"100%","min-height":"380px"},attrs:{"center":_vm.coordinates,"zoom":15}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }